export default __webpack_public_path__ + "8f887a1ed26531b734a835238f6209a8.png";